import { ReactNode } from "react";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { TrialStatusBanner } from "./TrialStatusBanner";

interface MainLayoutProps {
  children: ReactNode;
}

/**
 * MainLayout - Wraps content with the Navigation and Footer
 * This component should be used to provide consistent layout across the app.
 * IMPORTANT: Do not include Navigation or Footer in individual page components.
 */
export const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <TrialStatusBanner />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  );
}; 
 